import request from '../../utils/request';

/**
 * 获取体测成绩
 * @param query
 * @returns {AxiosPromise}
 */
export const getTranscript = (param) => {
    return request({
        url: '/sys/sportTest/page',
        method: 'GET',
        params:param
    });
}
/***
 * 导入
 * @param file FormData（含 file + 可选的 visibleEndTime）
 * @returns {AxiosPromise}
 */export const importFile = (file) => {
    return request({
        url: '/sys/sportTest/importFile',
        method: 'post',
        data: file
    });
};
/**
 * 导出二维码表格
 * @param query
 * @returns {AxiosPromise}
 */
export const fileExport = (param) => {
    return request({
        url: '/sys/sportTest/export',
        method: 'get',
        responseType: 'arraybuffer',
        params: param
    });
}
/**
 * 导出准考证
 * @param param
 * @returns {AxiosPromise}
 */
export const exportSportTestTicket = (param) => {
    return request({
        url: '/sys/sportTest/exportSportTestTicket',
        method: 'get',
        params: param
    });
}
/**
 * 导出学员成绩
 * @param query
 * @returns {AxiosPromise}
 */
export const exportResults = (param) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/exportFile',
        method: 'get',
        responseType: 'arraybuffer',
        params: param
    });
}

/**
 * 查看单个学员的体测成绩（只读，不重算不回写）
 *
 * 列表接口已不再带成绩（去掉 N+1 collection），点「查看成绩」时按 id 单独取。
 */
export const getStudentSportResult = (id) => {
    return request({
        url: '/sys/sportTest/studentResults',
        method: 'get',
        params: { id }
    });
}

/**
 * 体测计划列表 —— 含状态、实时学员数、可见截止时间、当前是否可见
 *
 * @param keyword 计划名 / 学校名模糊
 * @param status  0待测 1进行中 2已完成 3已归档；不传 = 全部
 */
export const getPlanList = (keyword, status) => {
    return request({
        url: '/sys/sportTest/planList',
        method: 'get',
        params: { keyword, status }
    });
}

/**
 * 修改计划基本信息（名称/测试日期/地区/项目/负责人/备注/可见时间/状态）
 *
 * ⚠️ school 不允许改 —— 它和 5 万行 sports_test.school 是同一个值。
 */
export const updatePlan = (data) => {
    return request({
        url: '/sys/sportTest/updatePlan',
        method: 'post',
        data
    });
}

/** 计划状态流转：0待测 1进行中 2已完成 3已归档 */
export const updatePlanStatus = (id, status) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/updatePlanStatus',
        method: 'post',
        params: { id, status }
    });
}

/** 快捷改可见截止时间（visibleEndTime 传空 = 长期可见） */
export const updatePlanVisible = (param) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/updateBatchVisible',
        method: 'post',
        params: param
    });
}

/** 编辑学员（改学号会同步改 code，否则准考证扫出来还是旧学号） */
export const updateStudent = (param) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/updateStudent',
        method: 'post',
        params: param
    });
}

/** 删除单个学员（物理删除 + 归档，删除后同一学号可以重新导入） */
export const deleteStudent = (id, reason) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/deleteStudent',
        method: 'post',
        params: { id, reason }
    });
}

/** 清空某计划下全部学员（物理删除 + 逐行归档），成功后可直接重新导入 */
export const clearPlanStudents = (planId, reason) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/clearPlanStudents',
        method: 'post',
        params: { planId, reason }
    });
}

/** 某个学员的成绩变更历史 */
export const getScoreHistory = (sportsTestId) => {
    return request({
        url: '/sys/sportTest/scoreHistory',
        method: 'get',
        params: { sportsTestId }
    });
}

/** 回滚某次成绩变更 */
export const revertScore = (logId) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/revertScore',
        method: 'post',
        params: { logId }
    });
}

/** 作废某条成绩行（错项清理，软删除） */
export const voidResult = (resultId, remark) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/voidResult',
        method: 'post',
        params: { resultId, remark }
    });
}

/**
 * 体测模块配置（目前只有「家长查成绩是否要图片验证码」）
 *
 * 返回 { captchaEnabled: boolean, queryLimitPerMinute: '12' }
 */
export const getSportTestConfig = () => {
    return request({
        url: '/sys/sportTest/config',
        method: 'get'
    });
}

/**
 * 保存「家长查成绩是否要图片验证码」
 *
 * 单独一个接口是为了不导入也能改：上线后发现被刷了才来开，不该逼业务重导 Excel。
 */
export const saveSportTestConfig = (captchaEnabled) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/saveConfig',
        method: 'post',
        params: { captchaEnabled }
    });
}

/**
 * 删除空计划（2026-10-20）。
 *
 * ⚠️ 只有「学员数为 0」的计划能删：school 上有 UNIQUE，导入时学校名打错留下的
 *    垃圾计划不删掉会永久占着那个标识；但有学员的计划删了等于把学员变成孤儿，
 *    服务端会直接拒绝。
 */
export const deletePlan = (id) => {
    return request({
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
        url: '/sys/sportTest/deletePlan',
        method: 'post',
        params: { id }
    });
}
